var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{on:{"beforeEnter":_vm.events.beforeEnter,"enter":_vm.events.enter,"afterEnter":_vm.events.afterEnter,"beforeLeave":_vm.events.beforeLeave,"leave":_vm.events.leave,"afterLeave":_vm.events.afterLeave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }